require('./app');

$(function () {
    let forgotPasswordErrorTrigger = $('#forgot-password-error-trigger'),
        forgotPasswordErrorText = $("#forgot-password-alert-error-text"),
        forgotPasswordModal = $('#forgot-password-modal'),
        forgotPasswordSuccessTrigger = $('#forgot-password-success-trigger'),
        forgotPasswordSuccessText = $("#forgot-password-alert-text"),
        forgotPasswordAlertModal = $('#forgot-password-alert');

    if (forgotPasswordErrorTrigger.length) {
        forgotPasswordErrorText.removeClass('d-none');
        forgotPasswordErrorText.html(forgotPasswordErrorTrigger.val());
        forgotPasswordModal.modal('show');
    }

    if (forgotPasswordSuccessTrigger.length) {
        window.helpers.showNotification(forgotPasswordSuccessTrigger.val(), 'success');
    }

    if (window.helpers.getQueryVariable('login_complete') === "true") {
        let newUrl = window.location.href;
        newUrl = newUrl.replace('?login_complete=true&', '?');
        newUrl = newUrl.replace('?login_complete=true', '');
        newUrl = newUrl.replace('&login_complete=true', '');
        window.location.href = newUrl;
    }

    if (window.helpers.getQueryVariable('login') === "failed") {
        window.history.replaceState({}, document.title, window.location.href.replace('?login=failed', ''));
        window.history.replaceState({}, document.title, window.location.href.replace('&login=failed', ''));
        $('#login-errors').removeClass('d-none');
        $("#insiders-login-form").modal('show');
    }

    if ($('#registration-has-errors').length) {
        $('#insiders-register-form').modal('show');
    }

// console.log($('#gform_wrapper_1').hasClass('gform_validation_error'));
    if ($('#gform_wrapper_1').hasClass('gform_validation_error')) {
        $('#insiders-register-form').modal('show');
    }

    $('#input_1_3').on('change', function () {
        let newValue = $(this).val().replace('+', '');
        $('#input_1_5').val(newValue);
    });

    if ($('#show-registration-dialog').length) {
        $('#insiders-register-form').modal('show');
    }

    if ($('#account-already-exists-dialog').length) {
        $('#account-already-exists').modal('show');
    }

    if ($('#registration-success').length) {
        let email = $('#registration-success-email').val();
        $('#registration-success-message').removeClass('d-none');
        $('#user_login').val(email);
        $('#insiders-login-form').modal('show');
    }

    if ($('#loginform').length) {
        let loginForm = $('#loginform');

        loginForm.find('label').addClass('sr-only');
        loginForm.find('.login-username').find('input').attr('placeholder', 'Email Address');
        loginForm.find('.login-password').find('input').attr('placeholder', 'Password');
    }
});
